exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gray-600[data-v-27e002fe] {\n  color: #949494;\n}\n", ""]);

// exports
